// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__KCpLn","rotation":"style_rotation__F+-iC"};